import { createSlice } from "@reduxjs/toolkit";



export const projectsSlice = createSlice({
    name: 'projects',
    initialState: {
        projects: null
        // [
        //     {name: 'Women shoes', type: 'keyword', themes: [
        //     {name: 'women leather shoes', keywords: [{keyword: 'women leather shoe', volume: 20000, cpc: '$12'}]},
        //     {name: 'women sports shoes', keywords: [{keyword: 'women pink sport shoe', volume: 20000, cpc: '$12'}, {keyword: 'woman sports shoes', volume: 19000, cpc: '$10'}]}]
        //     },
        //     {name: 'ice cream recipe', type: 'keyword', themes: [
        //     {name: 'vanilla ice cream', keywords: [{keyword: 'vanilla ice cream', volume: 9000, cpc: '$11'}]},
        //     {name: 'chocolate ice cream', keywords: [{keyword: 'choco ice creams', volume: 20000, cpc: '$12'}, {keyword: 'ice cream cocoa', volume: 19000, cpc: '$10'}]}]
        //     }
        // ]
    },
    reducers: {
        updateProjects: (state, action) => {
            state.projects = action.payload
            // return {
            //     ...state,
            //     projects: action.payload
            // }
        },
        addThemes: (state, action) => {
            const updatedProjects = state.projects.map(proj=> {
                if(proj.name.toLowerCase() === action.payload.pName.toLowerCase() && proj.type === 'keyword') {
                    return action.payload.updatedProject
                }

                return proj
            })

            state.projects = updatedProjects
        },
        addKeywords: (state, action) => {
            const kProj = state.projects.find(obj => obj.name === action.payload.pName && obj.type === 'keyword');

            if (kProj) {
                const themeIndex = kProj.themes.findIndex(theme => theme.name === action.payload.theme);
        
                if (themeIndex !== -1) {
                    // Merge existing keywords with new ones
                    const existingKeywords = kProj.themes[themeIndex].keywords;
                    const newKeywords = action.payload.keywords;
        
                    // Use a Set to filter out duplicates
                    const keywordMap = new Map();
                    
                    // Add existing keywords to the Map
                    existingKeywords.forEach(keyword => {
                        keywordMap.set(keyword.keyword, keyword);
                    });
        
                    // Add new keywords to the Map (overwrite if duplicate)
                    newKeywords.forEach(keyword => {
                        keywordMap.set(keyword.keyword, keyword);
                    });
        
                    // Convert the Map values to an array
                    kProj.themes[themeIndex].keywords = Array.from(keywordMap.values());
                }
            }
        
            return state;
        },
        addContentIdeas: (state, action) => {
            const cProj = state.projects.find(obj => obj.name === action.payload.pName && obj.type === 'content-ideas');
        
            if (cProj) {
                // Merge existing content ideas with new ones
                const existingIdeas = cProj.data;
                const newIdeas = action.payload.ideas;
        
                // Use a Map to filter out duplicates (keyed by 'keyword' field)
                const ideasMap = new Map();
        
                // Add existing content ideas to the Map
                existingIdeas.forEach(idea => {
                    ideasMap.set(idea.keyword, idea); // Assuming 'keyword' is the unique identifier for content ideas
                });
        
                // Add new content ideas to the Map (overwrite if duplicate)
                newIdeas.forEach(idea => {
                    ideasMap.set(idea.keyword, idea); // Overwrite any duplicates
                });
        
                // Convert the Map values to an array
                cProj.data = Array.from(ideasMap.values());
            }
        
            return state;
        },
        deleteContentIdea: (state, action) => {
            const cProj = state.projects.find(obj => obj.name === action.payload.projectName && obj.type === 'content-ideas');
        
            if (cProj) {
                // Remove the content idea by filtering out the one with the matching keyword
                cProj.data = cProj.data.filter(idea => idea.keyword !== action.payload.keyword);
            }
        
            return state;
        },
        addCompData: (state, action)=> {
            const updatedProjects = state.projects.map(proj=> {
                if(proj.name.toLowerCase() === action.payload.pName.toLowerCase() && proj.type === 'competition') {
                    return action.payload.updatedProject
                }

                return proj
            })

            state.projects = updatedProjects
        },
        updateSiteReport: (state, action) => {
            const updatedProjects = state.projects.map(proj=> {
                if(proj.name.toLowerCase() === action.payload.pName.toLowerCase() && proj.type === 'site-report') {
                    return action.payload.updatedProject
                }

                return proj
            })

            state.projects = updatedProjects
        }
    }
})


export const { updateProjects, addThemes, addKeywords, addCompData, updateSiteReport, addContentIdeas, deleteContentIdea } = projectsSlice.actions
export default projectsSlice.reducer